import React from 'react';
import PropTypes from 'prop-types';

import { StyledFieldRow } from './styled';

const FieldRow = props => {
  const { marginTop, marginBottom, marginSides, children } = props;

  return (
    <StyledFieldRow marginTop={marginTop} marginBottom={marginBottom} marginSides={marginSides} {...props}>
      {children}
    </StyledFieldRow>
  );
};

FieldRow.propTypes = {
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  marginSides: PropTypes.string,
  children: PropTypes.node,
};

export { FieldRow };
